module.exports = __webpack_public_path__ + "assets/icon-variation-zero.b767b066.svg";